export default __webpack_public_path__ + "32f08e483b2624677795febe96c815c5.svg";